import { com, kotlin } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import { requireAuthContext } from '../../authorization/GlobalAuthContext'
import EntityToCreate = com.eidu.sharedlib.entity.api.entities.EntityToCreate
import PostEntitiesRequest = com.eidu.sharedlib.entity.api.entities.PostEntitiesRequest
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import KtList = kotlin.collections.KtList
import PostEntitiesResponse = com.eidu.sharedlib.entity.api.entities.PostEntitiesResponse

export class ConflictError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ConflictError'
  }
}

type PostEntitiesParameters = { entities: readonly EntityToCreate[] }

const postEntities = async ({ entities }: PostEntitiesParameters) => {
  const authContext = await requireAuthContext()
  const response = await fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/entities`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: serializeToJsonString(new PostEntitiesRequest(KtList.fromJsArray(entities))),
    method: 'POST',
  })
  if (response.status !== 201) throw Error(`Unexpected response code ${response.status} from postEntities endpoint`)

  return PostEntitiesResponse.fromJsonString(await response.text())
}

export default postEntities
